module.exports = __webpack_public_path__ + "static/media/tooltip.f85272d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tooltip.svg
// module id = 981
// module chunks = 3